// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"f6e3ae15","222":"3ff37d45","526":"37db7118","962":"a254b08e"}[chunkId] + ".chunk.css";
};